import MDTypography from "components/MDTypography";
import { IconButton, Box } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import AuthenticationService from "application/modules/authentication/AuthenticationService";

function TelephoneCell({ value, onCall }) {
  const shouldShowIcon =
    value && AuthenticationService.getExtensionNumber() !== value;

  return (
    <Box display="flex" alignItems="center">
      {shouldShowIcon ? (
        <IconButton color="info" onClick={() => onCall && onCall(value)}>
          <CallIcon />
        </IconButton>
      ) : (
        <Box width={40} />
      )}
      <MDTypography variant="caption" fontWeight="medium" color="text">
        {value}
      </MDTypography>
    </Box>
  );
}

TelephoneCell.defaultProps = {
  suffix: "",
};

export default TelephoneCell;
